import Component from '../../component';
import WideWidgetContainer from '../wide-widget-container/wide-widget-container.model';
import CloseButton from '../close-button/close-button.model';
import { WideWidgetStyle } from './wide-widget-style';
import scrollEmitter from '../../../emitters/scroll.emitter';
import { Subscription } from '../../observer.model';
import styles from './wide.module.scss';
import { WIDGET_EXISTENCE_ERROR } from '../../../constants';
import { Dentolo } from '../../../dentolo';

interface WidgetApi {
	isActive():boolean
	show():void;
	hide():void;
	onClick(callback:(event:MouseEvent)=>void):void;
	destructor():void
}

export default class WideWidget extends Component implements WidgetApi {
	private closeButton:CloseButton;
	private container:WideWidgetContainer;
	private onClickSubscription:Subscription;
	private onHideSubscription:Subscription;

	public element:HTMLDivElement;

	constructor(
		style:WideWidgetStyle, 
		zIndex:number, 
		private hideOnScrollingToBottom:boolean=false, 
		wideButtonOnMobiles?:Dentolo.WideButtonOnMobilesOptions,
    offer?: string,
    buttonText?: string,
    background?: string,
    buttonShadow?: string
	) {
		super();
		this.element = document.createElement('div');
		this.element.dataset.nameSpace = 'dentolo';
		this.element.id = 'dentolo_wide-widget';
		this.element.style.zIndex = String(zIndex);
		this.element.className = styles[style];

    if (background) this.element.style.background = background;

		this.closeButton = new CloseButton(style);
		this.container = new WideWidgetContainer(style, wideButtonOnMobiles, offer, buttonText, buttonShadow);

		this.element.appendChild(this.container.element);
		this.element.appendChild(this.closeButton.element);

		this.scrollHandler = this.scrollHandler.bind(this);
	}

	private scrollHandler(e:Event):void {
		const { pageYOffset, innerHeight } = window;

		if (pageYOffset + innerHeight*1.1 >= document.body.offsetHeight) {
		  this.element.classList.add(styles.hidden);
		} else this.element.classList.remove(styles.hidden);
	}

	public isActive():boolean {
		return !this.element.classList.contains(styles.hidden);
	}

	public show():void {
		if (this.isActive()) return;
		this.element.classList.remove(styles.hidden);

		if (this.hideOnScrollingToBottom) {
			scrollEmitter.subscribe(this.scrollHandler);
		}
	}

	public hide():void {
		if (!this.isActive()) return;
		this.element.classList.add(styles.hidden);

		if (this.hideOnScrollingToBottom) {
			scrollEmitter.unsubscribe(this.scrollHandler);
		}
	}

	public onClick(callback:(event:MouseEvent)=>void):void {
		this.onClickSubscription = this.container.onClick(callback);
	}

	public onHide(callback:()=>void):void {
		this.onHideSubscription = this.closeButton.onClick(callback);
	}

	public destructor():void {
		scrollEmitter.unsubscribe(this.scrollHandler);
		this.onClickSubscription.unsubscribe();
		this.onHideSubscription.unsubscribe();
		this.onClick = ():never=> { throw new Error(WIDGET_EXISTENCE_ERROR) };
		this.onHide = ():never=> { throw new Error(WIDGET_EXISTENCE_ERROR) };
		this.hide = ():never=> { throw new Error(WIDGET_EXISTENCE_ERROR) };
		this.show = ():never=> { throw new Error(WIDGET_EXISTENCE_ERROR) };
		this.scrollHandler = ():never=> { throw new Error(WIDGET_EXISTENCE_ERROR) };
		this.isActive = ():never=> { throw new Error(WIDGET_EXISTENCE_ERROR) };
	}
}